/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditVenueBodyBody,
    GetVenuesParams,
    RequestStatusResponseResponse,
    VenueCreateSuccessResponseResponse,
    VenueSuccessResponseResponse,
    VenuesSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new venue
 */
export const addVenue = (addEditVenueBodyBody: AddEditVenueBodyBody, signal?: AbortSignal) => {
    return customInstance<VenueCreateSuccessResponseResponse>({
        url: `/venues`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditVenueBodyBody,
        signal,
    });
};

export const getAddVenueMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addVenue>>,
        TError,
        { data: AddEditVenueBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addVenue>>,
    TError,
    { data: AddEditVenueBodyBody },
    TContext
> => {
    const mutationKey = ['addVenue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addVenue>>,
        { data: AddEditVenueBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addVenue(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddVenueMutationResult = NonNullable<Awaited<ReturnType<typeof addVenue>>>;
export type AddVenueMutationBody = AddEditVenueBodyBody;
export type AddVenueMutationError = APIErrorResponseResponse;

/**
 * @summary Add new venue
 */
export const useAddVenue = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addVenue>>,
        TError,
        { data: AddEditVenueBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addVenue>>,
    TError,
    { data: AddEditVenueBodyBody },
    TContext
> => {
    const mutationOptions = getAddVenueMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get venues matching the filters
 */
export const getVenues = (params?: GetVenuesParams, signal?: AbortSignal) => {
    return customInstance<VenuesSuccessResponseResponse>({
        url: `/venues`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetVenuesQueryKey = (params?: GetVenuesParams) => {
    return [`/venues`, ...(params ? [params] : [])] as const;
};

export const getGetVenuesQueryOptions = <
    TData = Awaited<ReturnType<typeof getVenues>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetVenuesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getVenues>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetVenuesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenues>>> = ({ signal }) =>
        getVenues(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getVenues>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetVenuesQueryResult = NonNullable<Awaited<ReturnType<typeof getVenues>>>;
export type GetVenuesQueryError = APIErrorResponseResponse;

/**
 * @summary Get venues matching the filters
 */

export function useGetVenues<
    TData = Awaited<ReturnType<typeof getVenues>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetVenuesParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getVenues>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetVenuesQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get venue by id
 */
export const getVenue = (id: number, signal?: AbortSignal) => {
    return customInstance<VenueSuccessResponseResponse>({
        url: `/venues/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetVenueQueryKey = (id?: number) => {
    return [`/venues/${id}`] as const;
};

export const getGetVenueQueryOptions = <
    TData = Awaited<ReturnType<typeof getVenue>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetVenueQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenue>>> = ({ signal }) =>
        getVenue(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getVenue>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetVenueQueryResult = NonNullable<Awaited<ReturnType<typeof getVenue>>>;
export type GetVenueQueryError = APIErrorResponseResponse;

/**
 * @summary Get venue by id
 */

export function useGetVenue<
    TData = Awaited<ReturnType<typeof getVenue>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetVenueQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit venue
 */
export const editVenue = (id: number, addEditVenueBodyBody: AddEditVenueBodyBody) => {
    return customInstance<VenueSuccessResponseResponse>({
        url: `/venues/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditVenueBodyBody,
    });
};

export const getEditVenueMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editVenue>>,
        TError,
        { id: number; data: AddEditVenueBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editVenue>>,
    TError,
    { id: number; data: AddEditVenueBodyBody },
    TContext
> => {
    const mutationKey = ['editVenue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editVenue>>,
        { id: number; data: AddEditVenueBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editVenue(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditVenueMutationResult = NonNullable<Awaited<ReturnType<typeof editVenue>>>;
export type EditVenueMutationBody = AddEditVenueBodyBody;
export type EditVenueMutationError = APIErrorResponseResponse;

/**
 * @summary Edit venue
 */
export const useEditVenue = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editVenue>>,
        TError,
        { id: number; data: AddEditVenueBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editVenue>>,
    TError,
    { id: number; data: AddEditVenueBodyBody },
    TContext
> => {
    const mutationOptions = getEditVenueMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete venue by id
 */
export const deleteVenue = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/venues/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteVenueMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteVenue>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteVenue>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteVenue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenue>>, { id: number }> = (
        props,
    ) => {
        const { id } = props ?? {};

        return deleteVenue(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteVenueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenue>>>;

export type DeleteVenueMutationError = APIErrorResponseResponse;

/**
 * @summary Delete venue by id
 */
export const useDeleteVenue = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteVenue>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteVenue>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteVenueMutationOptions(options);

    return useMutation(mutationOptions);
};
